import { css } from '@emotion/css';

export const addSkillButtonStyles = css`
  padding: 0.5rem 1.2rem;
`;
